import { Towers } from "../Games/Towers/Towers";

export default function TowersPage() {
  return (
    <Towers />
  );
}
